import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Package, PackageWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreatePackage(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  PackageWrite
> {
  const queryClient = useQueryClient();

  const createPackage = useCallback((newPackage: PackageWrite): Promise<AxiosResponse<Package>> => {
    return client.post('packages/', newPackage);
  }, []);

  return useMutation(createPackage, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
    },
  });
}
